import {
  AliceCardKycStatus,
  OnboardingStepType,
  OrganizationDetailFragment,
} from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult, HealthcheckType } from '../../types'
import { getOnboardingStepAssignee } from '../../utils/onboardingWorkflowUtils'

export const useKYCStatus = (
  org: OrganizationDetailFragment | null | undefined,
  onboardingWorkflow?: OrganizationDetailFragment['onboardingWorkflow']
): HealthcheckStatusResult => {
  const assignee = getOnboardingStepAssignee(onboardingWorkflow, OnboardingStepType.CompleteKyc)
  const healthcheckTitle = 'Company Representative'
  const baseProperties = {
    assignee,
    healthcheckTitle,
    healthcheckType: HealthcheckType.CompleteKyc,
    primary: healthcheckTitle,
  } as const

  if (!org) {
    return {
      status: 'disabled',
      secondary: 'Loading company representative information...',
      ...baseProperties,
    }
  }

  if (org.aliceCardProgram.kycStatus === AliceCardKycStatus.Complete) {
    return {
      status: 'complete',
      secondary: 'We have received your company representative information',
      ...baseProperties,
    }
  }

  const isStarted = org.aliceCardProgram.kycStatus === AliceCardKycStatus.Started
  const status = isStarted ? 'pending' : 'incomplete'
  return {
    status,
    secondary: 'Required for financial compliance purposes.',
    ...baseProperties,
  }
}
